// extracted by mini-css-extract-plugin
module.exports = {"heading":"products_heading__q57V3","cards":"products_cards__1-AZQ","element":"products_element__1eQo3"};